// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.holdstation",
    name: "Holdstation Wallet",
    homepage: "https://www.holdstation.com",
    image_id: "dba228fc-d0c9-497b-903e-843ad1076e00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/holdstation-web3-wallet/id6444925618",
        android: "https://play.google.com/store/apps/details?id=io.holdstation",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "holdstation://",
        universal: "https://staging-referral.holdstation.com/wallet-connect?uri=",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map